import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import Colors from "../../theme/colors";

interface Props {
  message?: string | null;
}

const ErrorModal = ({
  message = "This is a error message."
}: Props): JSX.Element => (
  <Grid
    container
    direction="column"
    spacing={16}
    alignContent="center"
    alignItems="center"
  >
    <Grid item>
      <FontAwesomeIcon color={Colors.danger} size="5x" icon={faTimesCircle} />
    </Grid>
    <Grid item>
      <Typography style={{ color: Colors.danger }} variant="h5">
        Error!
      </Typography>
    </Grid>
    <Grid item>
      <Typography style={{ color: Colors.danger }} variant="h6">
        {message}
      </Typography>
    </Grid>
  </Grid>
);

export default ErrorModal;
